// src/About/AboutPage.tsx
import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <div>
      <h1>About Page</h1>
      {/* Add your page content here */}
    </div>
  );
};

export default AboutPage;
